<template>
  <list-layout :tableTools="toggleTableTools">
    <template slot="header">
      <BaseHeader :content="header" />
    </template>
    <template slot="table-core">
      <base-table-pagination
        ref="baseTablePagRef"
        :total="pagination.total"
        :currentPage="pagination.currentPage"
        :perPage="pagination.pageSize"
        @changeCurrentPage="changeCurrentPage"
        @changePerPage="changePerPage"
      ></base-table-pagination>
      <div class="flex flex-row w-100">
        <base-table-refresh @applyFilters="applyFiltersHandler" />
        <base-table-searches @toggleSearchesDialog="toggleSearchesDialog" />
        <base-table-search @toggleFilters="toggleFilters" />
      </div>
    </template>
    <template slot="table-tags">
      <base-table-filter-tags  :tags="tags" @removeTag="removeFilterTagHanlder" @removeAllTags="removeAllTagsHandler" @saveTags="saveTagsHandler"/>
    </template>
    <template slot="table-component">
    <kendo-grid-component :spanish="spanish"
      :dataResult='kendo.dataResult'
      :kendo="kendo"
      :loading='isGeneralLoading'
      :selectedField="selectedField"
      @datastatechange='dataStateChange'
      @columnreorder='columnReorder'
      @rowclick='openPath'
      @columnssubmit='onColumnsSubmit'
      @sortchange='sortChange'
      @filterchange='filterChange'>
    </kendo-grid-component>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode='primary' :text="labelBtnExcel" icon='excelxls' @click='exportExcel' :loading='isGeneralLoading || loadingExcel' :disabled="loadingExcel"/>
        </template>
      </base-footer>
    <filter-panel :panelOpen="filterPanel" @togglePanel="toggleFilters" @applyFilters="applyFiltersHandler" />
    <create-search-dialog 
        :numberSearches="numberSearches"
        :idVista="idVista" 
        :dialogOpen="saveSearchDialog" 
        :tags="tags" 
        @toggleDialog="toggleDialogSearches" 
        @applyDialog="applySearchHandler" />
      <filter-panel-searches 
        ref="filterPanelSearches" 
        :idVista="idVista" 
        :vuexnamespace="vuexnamespace" 
        :panelOpen="searchesPanel" 
        @togglePanel="toggleSearchesDialog" 
        @applyFilters="applyFiltersHandler" 
        @updateNumberSearches="updateNumberSearches"/>
    </template>
  </list-layout>
</template>

<script>
import ListLayout from '@/components/layout/ListLayout.vue'
import FilterPanel from '@/components/filters/HistoricalConfigFlowFilter.vue'
import FilterPanelSearches from '@/components/searches/SearchesPanel.vue'
import CreateSearchDialog from '@/components/searches/CreateSearchDialog.vue'
import { i18n } from '@/i18n'
// import moment from 'moment'
import '@progress/kendo-theme-default/dist/all.css'
import { process } from '@progress/kendo-data-query'
import KendoGridComponent from '../../components/KendoGridComponent.vue'

import { getFlow } from '@/services/configurations/rules/getFlow'
import { getHistoricalByFlow } from '@/services/historical/getHistoricalByFlow'
import { getHistoricalByFlowExcel } from '@/services/historical/getHistoricalByFlowExcel'

export default {
  name: 'config-flow-historical',
  components: {
    ListLayout,
    FilterPanel,
    FilterPanelSearches,
    CreateSearchDialog,
    KendoGridComponent
  },
  data: function () {
    return {
      idVista: 82,
      // Searches
      numberSearches: 0,
      saveSearchDialog: false,
      searchesPanel: false,
      // All
      loadingExcel: false,
      spanish: true,
      header: {
        title: i18n.t('historical.generic'),
        icon: 'config',
        breadcrumb: null,
        url: 'configurations/configflow/details'
      },
      vuexnamespace: 'historicalConfigflow',
      selectedField: 'selected',
      filterPanel: false,
      showAllRows: true,
      loadingDataTable: false,
      tableData: [],
      data: null,
      selected: [],
    }
  },
  computed: {
    labelBtnExcel: function () {
      if (this.hasSelected) return this.$i18n.t('app.export_excel') + ' (Seleccionados)'
      return this.$i18n.t('app.export_excel')
    },
    kendo: function () {
      return this.$store.getters[this.vuexnamespace + '/getKendo']
    },
    isHeadCoreReady: function () {
      return this.$store.getters.isHeadCoreReady
    },
    toggleTableTools: function () {
      return this.selected.length > 0
    },
    rowsSelected: function () {
      return this.selected.length
    },
    rowsTotal: function () {
      return this.tableData.length
    },
    setLabelTowShow: function () {
      return this.showAllRows ? 'Solo Seleccionadas' : 'Ver Todas'
    },
    masterFilters: function () {
      return this.$store.getters[this.vuexnamespace + '/getMasterFilters']
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    headerCoreFilters: function () {
      return this.$store.getters['auth/queryHeaders']
    },
    tags: function () {
      return this.$store.getters[this.vuexnamespace + '/getTags']
    },
    pagination: function () {
      return this.$store.getters[this.vuexnamespace + '/getPaginationInfo']
    },
    columns () {
      return [
        { field: 'selected', width: '50px', headerSelectionValue: this.areAllSelected, reorderable: false, groupable: false },
        ...this.kendo.columns
      ]
    },
    areAllSelected () {
      return this.kendo.dataResult.data.findIndex(item => item.selected === false) === -1
    },
    hasSelected () {
      return this.selected.length > 0
    },
    role: function () {
      return this.$store.getters['auth/role']
    }
  },
  watch: {
    headerCoreFilters: {
      // immediate: true,
      deep: true,
      handler: 'headerCoreFiltersHandler'
    },
    data (val, oldVal) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group
      }
      this.kendo.dataResult = process(val, dataState)
    }
  },
  created: function () {
    // console.log('created: ')
  },
  mounted: async function () {
    const dataId = this.$route.params.id
    try {
      this.$store.commit(this.vuexnamespace + '/setPageSize', this.kendo.take)
    } catch (error) {
      console.log(error)      
    }

    const breadcrumbs = []
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/configflow', name: this.$i18n.t('app.configflow') })

    const data = await this.downloadData(dataId)
    breadcrumbs.push({ path: '', name: data.Nombre })
    this.$store.commit('app/setheaderBreadCrumb', data.Nombre)
    this.header.breadcrumb = breadcrumbs

    this.applyFilters()
  },
  methods: {
    openPath: function (event) {
      // console.log('Ir a registro con ID: ', event.dataItem.id)
      // this.$router.push({ name: 'configurations/tags/details', params: { id: event.dataItem.idGrupo } })
    },
    toggleFilters: function () {
      this.filterPanel = !this.filterPanel
    },
    removeFilterTag: function (tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    createAppState: function (dataState) {
      this.kendo.take = dataState.take
      this.kendo.skip = dataState.skip
      if (dataState.group) {
        // eslint-disable-next-line no-return-assign
        dataState.group.map(group => group.aggregates = this.aggregates)
      }
      this.kendo.group = dataState.group
      this.kendo.filter = dataState.filter
      this.kendo.sort = dataState.sort
    },
    dataStateChange: async function (event) {
      this.createAppState(event.data)
      this.data = await this.applyFilters()
    },
    columnReorder: function (options) {      
      this.sendUpdatedColumns(options.columns)
      this.kendo.columns.forEach((column, index) => {
        if (options.columns.filter(x => x.field === column.field).length === 0) {
          column.orderIndex = index + this.kendo.columns.length
          options.columns.push(column)
        }
      })
      this.kendo.columns = options.columns
    },
    exportExcel: async function () {
      this.$store.commit('app/setLoading', true)
      this.loadingExcel = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      const params = {
        idFlujoAutomatico: this.$route.params.id,
        evento: data.evento ? data.evento.value : null,
        mensaje: data.mensaje ? data.mensaje.value : null,
        usuario: data.usuario ? data.usuario.value : null,
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      const objColumnas = this.getColumnsGroupExcelMixin(this.kendo.columns, this.kendo.group)
      const payload = { order: objOrder.order, grupos: objColumnas }
      if (this.hasSelected) {
        const selectedIDs = this.selected.map(x => x.idevento)
        payload.listaIDs = selectedIDs
      }
      payload.eventos = data.eventoMultiple ? data.eventoMultiple.value : null
      try {
        const response = await getHistoricalByFlowExcel(payload, params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'flujo-automatico-historico.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
        this.loadingExcel = false
      }
    },
    onColumnsSubmit: function (columnsState) {
      this.sendUpdatedColumns(columnsState)
      this.kendo.columns = columnsState
    },
    sortChange: function (e) {
      // console.log('sortChange => sort', e)
      let sort = e.sort
      if (Array.isArray(e)) {
        sort = e
      }
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: sort,
        group: this.kendo.group,
        filter: this.kendo.filter
      }
      this.dataStateChange({ data: dataState })
    },
    filterChange: function (filter) {
      const dataState = {
        skip: this.kendo.skip,
        take: this.kendo.take,
        sort: this.kendo.sort,
        group: this.kendo.group,
        filter: filter
      }

      this.dataStateChange({ data: dataState })
    },
    applyFilters: async function (eventData) {
      this.loadingDataTable = true
      const data = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      // console.log('applyFilters', data)
      const params = {
        idFlujoAutomatico: this.$route.params.id,
        evento: data.evento ? data.evento.value : null,
        mensaje: data.mensaje ? data.mensaje.value : null,
        usuario: data.usuario ? data.usuario.value : null,
        fechaDesde: data.fechaDesde ? data.fechaDesde.value : null,
        fechaHasta: data.fechaHasta ? data.fechaHasta.value : null
      }
      const objOrder = this.getObjOrderMixin(this.kendo.group, this.kendo.sort)
      objOrder.eventos = data.eventoMultiple ? data.eventoMultiple.value : null
      try {
        this.data = await this.getItemsData(objOrder, params)
      } catch (error) {
        // console.log('error', error)
        this.$store.commit('setIsLoading', false)
        this.doFeedback(this.$i18n.t('feedback.error.general ' + error))
      }
      return this.data
    },
    getItemsData: async function (orders, filters) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const res = await this.getMainData(orders, params)
      this.data = res.listaEventos
      const pagination = {
        total: res.meta?.total,
        currentPage: res.meta?.currentPage,
        totalPages: res.meta?.lastPage,
        pageSize: res.meta?.perPage
      }
      
      this.updatePersistedSortMixin()
      this.$store.commit(this.vuexnamespace + '/setPaginationInfo', pagination)
      this.$store.commit('setIsLoading', false)
      this.loadingDataTable = false
      return this.data
    },
    async getMainData (orders, filters) {
      const params = {
        paginate: true,
        results: this.pagination.pageSize,
        page: this.pagination.currentPage,
        ...filters
      }
      const data = await getHistoricalByFlow(orders, params)
      if (data.blnError === true) {
        this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
      } else {
        setTimeout(() => {
          this.$nextTick(() => { 
            if (this.$refs.baseTablePagRef) this.$refs.baseTablePagRef.focus() 
          })
          this.doFeedback('Se han refrescado los datos del grid actual', 'info', 3000, true)
        }, 200)
      }
      if (data !== null && data.listaEventos !== null && data.listaEventos !== undefined) {
        data.listaEventos.forEach(o => {
          o.evento = o.evento.replaceAll('_', ' ')
        })
      }
      return data
    },
    applyFiltersHandler: async function (eventData) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.data = await this.applyFilters(eventData)
    },
    changeCurrentPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', event)
      this.data = await this.applyFilters(null)
    },
    changePerPage: async function (event) {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/setPageSize', event)
      this.kendo.take = event
      this.data = await this.applyFilters(null)
    },
    removeFilterTagHanlder: function (tag) {
      // this.$store.commit(this.vuexnamespace + '/removeTag', tag)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      const filter = this.$store.getters[this.vuexnamespace + '/getAppliedFilters']
      delete filter[tag[0]]
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', filter)
      this.applyFiltersHandler(null)
    },
    headerCoreFiltersHandler: function (obs) {
      if (this.isHeadCoreReady) {
        this.applyFilters(null)
      }
    },
    removeAllTagsHandler: function () {
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.$store.commit(this.vuexnamespace + '/resetMasterFilters')
      this.applyFiltersHandler(null)
    },
    tableSortByChangeHandler: function ({ prop, order }) {
      this.$store.commit(this.vuexnamespace + '/setSort', prop)
      this.$store.commit(this.vuexnamespace + '/setSortOrder', order)
      this.$store.commit(this.vuexnamespace + '/setCurrentPage', 1)
      this.applyFilters(null)
    },
    downloadData: async function (id) {
      let data = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idFlujoAutomatico: id
        }
        data = await getFlow(params)
        if (data.blnError === true) {
          this.doFeedback(data.msgError + ' [Código de error: ' + data.codError + ']')
        } else {
          data = data.Respuesta
        }
      } catch (error) {
        console.log(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return data
    },
    toggleSearchesDialog: function () {
      this.searchesPanel = !this.searchesPanel
    },
    saveTagsHandler: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    toggleDialogSearches: function () {
      this.saveSearchDialog = !this.saveSearchDialog
    },
    applySearchHandler: async function () {
      this.toggleDialogSearches()
      // Manda actualizar lista de búsquedas
      this.$refs.filterPanelSearches.updateData()
    },
    updateNumberSearches: async function (number) {
      this.numberSearches = number
    },
  }
}
</script>
